import ajax from "@/libs/Ajax";
import Ajax from "@/libs/Ajax";

let NAME_SPACE = "/ClientController";

export default {
  getInfo() {
    return ajax.get(`${NAME_SPACE}/getInfo`);
  },
  startAll() {
    return ajax.get(`${NAME_SPACE}/startAll`);
  },
  stopAll() {
    return ajax.get(`${NAME_SPACE}/stopAll`);
  },
  syncBizChain() {
    return ajax.get(`${NAME_SPACE}/syncBizChain`);
  },
  onlineRefresh() {
    return ajax.get(`${NAME_SPACE}/onlineRefresh`);
  },
  onlineUpdate() {
    return ajax.get(`${NAME_SPACE}/onlineUpdate`);
  },
  isOnlineSupport(){
    return Ajax.get(`${NAME_SPACE}/isOnlineSupport`);
  }
}